import { render, staticRenderFns } from "./AbaOutrasInfo.vue?vue&type=template&id=54d7434c&"
import script from "./AbaOutrasInfo.vue?vue&type=script&lang=js&"
export * from "./AbaOutrasInfo.vue?vue&type=script&lang=js&"
import style0 from "./AbaOutrasInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports